<div class="board-type-selector">
  <div class="selector-header">
    <h2>Select Board Type</h2>
    <p>Choose the type of board you want to create</p>
  </div>

  <div class="board-type-cards">
    <mat-card 
      *ngFor="let option of boardTypeOptions" 
      class="board-type-card"
      [class.disabled]="!option.available"
      (click)="selectBoardType(option.value, option.available)">
      
      <mat-card-header>
        <mat-card-title>
          {{ option.label }}
          <span *ngIf="!option.available" class="coming-soon-badge">Coming Soon</span>
        </mat-card-title>
      </mat-card-header>
      
      <mat-card-content>
        <div class="card-icon">
          <mat-icon>{{ option.icon }}</mat-icon>
        </div>
        <p>{{ option.description }}</p>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="selector-footer" style="text-align: center; margin-top: 30px;">
    <button mat-button (click)="cancel()">Cancel</button>
  </div>
</div>